let language = {
    PC_RESOURCE_LIB_SET_PUT_LIB_ON_PRODUCT_TIP: "您可以将贴纸、背景或前景放置在您的产品上。",
    PC_RESOURCE_LIB_SET_NOT_SUPPORT_LIB_TIP: "此产品不支持产品贴纸自定义",
    PC_RESOURCE_LIB_OPEN_TO_SELECT_CUSTOM_FACE_TIP: "请打开树结构以选择自定义面",
    PC_RESOURCE_LIB_CUSTOM_FACE_NOT_SUPPORT_PRODUCT_CUSTOMIZATION_TIP: "此自定义面不支持产品贴纸自定义",
    PC_RESOURCE_LIB_NO_MATCH_SEARCH_TIP: "没有符合搜索条件的内容。",
    PC_RESOURCE_LIB_IS_EMPTY_TIP: "您当前的资源库是空的。",
    
    // 
    PC_RESOURCE_LIB_SAVE_SETTING_SUCCESS_TIP: "保存成功。",
};

export { language }
